import CoreTransaction from 'core/js/pages/municipality-data/balance/account/_account_media_panel/_transaction'
import template from './_transaction.pug'

// @vue/component
export default {
  extends: CoreTransaction,
  template: template(),

  computed: {
    originZoneDescription() {
      return this.transaction.node_from_name || null
    },

    destinationZoneDescription() {
      return this.transaction.node_to_name || null
    },

    traveledKilometers() {
      const value = Number(this.transaction.kilometers_traveled)

      if (!Number.isFinite(value) || value <= 0) return null

      return `${value.toFixed(2)} km`
    },

    hasZoneInfo() {
      return false
    }
  }
}